import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Delete } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { DeleteCompetencyModal } from 'modules/competencies/components/CompetencyDeleteModal'

const CompetencySettingsHeader: FC<{
  competencyId: string
  competencyName: string
}> = ({ competencyId, competencyName }) => {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <>
      <ResourceHeader
        title={i18n.t('competencies_v3.settings.header.title')}
        otherActions={[
          {
            label: i18n.t('competencies_v3.competencies_table.actions.delete'),
            onClick: () => setShowDeleteModal(true),
            icon: Delete,
            critical: true,
          },
        ]}
      />
      {showDeleteModal && (
        <DeleteCompetencyModal
          competencyId={competencyId}
          competencyName={competencyName}
          onClose={() => {
            setShowDeleteModal(false)
          }}
          onSuccess={() => {
            navigate(navigation.competencies.fullPath())
          }}
        />
      )}
    </>
  )
}

export default CompetencySettingsHeader
